// src/admin/components/emailTemplates.js

export const LITTLE_HIBBA_TEMPLATE = `
<div style="text-align: center;">
    <img src="https://placehold.co/600x200/EADCD1/5A4E45.png?text=Little+Hibba+Studio" alt="Little Hibba Header" width="600" />
</div>
<p><br></p>
<h2 style="text-align: center; color: #5A4E45;">Stop Doubting the Gift Allah Gave You!</h2>
<p><br></p>
<p>Sometimes, the biggest obstacle standing in our way is self-doubt.</p>
<p>Shaytan wants us to believe that our talents are insignificant, that our dreams are impossible, and that we have nothing valuable to offer.</p>
<p><br></p>
<div style="text-align: center;">
    <img src="https://placehold.co/500x300/F4EFEA/5A4E45.png?text=Your+Inspiring+Image+Here" alt="Workshop Inspiration" width="500" />
</div>
<p><br></p>
<p>But the truth is every one of us has unique skills and potential that can benefit the Ummah. Too often, we block our own path before even taking the first step.</p>
<p><br></p>
<blockquote style="color: #5A4E45; font-style: italic;">
    "Change begins when you decide to believe in what Allah has already placed within you."
</blockquote>
<p><br></p>
<p>This is exactly why I created these workshops — not just for writers, but for anyone wanting to discover how they can grow within the publishing industry and contribute meaningfully to the Muslim community.</p>
<p>These are flexible opportunities that can fit around your schedule—making them especially valuable for mothers and women looking to earn while caring for their homes and families. A beautiful opportunity to benefit both your dunya and akhirah, InshaAllah.</p>
<p><br></p>
<p style="text-align: center; color: #5A4E45;"><strong>Explore the workshop and begin your journey here 👇</strong></p>
<h2 style="text-align: center;">
    <a href="https://studio.littlehibba.com" style="color: #D4B89C; text-decoration: underline;"><strong>JOIN WORKSHOP</strong></a>
</h2>
<p><br></p>
`;